module.exports = __webpack_public_path__ + "img/exit_3.cc4f3c1c.svg";